import apiClient from '../apiClient';
import { GET_CITY_IN_COUNTRY_URL } from '../apiUrl';

const getCityInCountryApi = Id => {
  return apiClient.get(GET_CITY_IN_COUNTRY_URL(Id));
};

export default getCityInCountryApi;
